import {
  Box,
  Flex,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { useState } from 'react';
import { SortingIcon } from '@lon/shared/components';
import { useGetIsLeaderSuitFlag } from '@lon/shared/hooks';

export default function HeaderWithPopover({
  item,
  headerData,
  sortTooltipLabel = '',
}: {
  item: {
    standard: string;
    description?: string;
  };
  headerData: any;
  sortTooltipLabel?: string;
}) {
  const [showDesc, setShowDesc] = useState(false);
  const isLeaderSuit = useGetIsLeaderSuitFlag();

  if (!item.description) {
    return (
      <Flex flexDirection="column" alignItems="center" gap={2} py={2}>
        <Tooltip
          variant="dark"
          label={t('reportsDashboard.noStandardDesciption') as string}
          aria-hidden={true}
          isDisabled={showDesc}
        >
          <Text
            color="primary.800"
            css={{
              writingMode: 'vertical-lr',
            }}
            transform="rotate(180deg)"
          >
            {headerData?.header?.id}
          </Text>
        </Tooltip>

        <Tooltip label={sortTooltipLabel} variant="dark">
          <Flex>
            <SortingIcon
              column={headerData?.column as any}
              onIconClick={
                isLeaderSuit
                  ? headerData?.column.getToggleSortingHandler()
                  : undefined
              }
            />
          </Flex>
        </Tooltip>
      </Flex>
    );
  }

  if (!isLeaderSuit) {
    return (
      <Tooltip variant="dark" label={item.description} aria-hidden={true}>
        <Flex flexDirection="column" alignItems="center" gap={2} py={2}>
          <Text
            color="primary.800"
            css={{
              writingMode: 'vertical-lr',
            }}
            transform="rotate(180deg)"
          >
            {headerData?.header?.id}
          </Text>
          <SortingIcon column={headerData?.column as any} />
        </Flex>
      </Tooltip>
    );
  }

  return (
    <Flex flexDirection="column" alignItems="center" gap={2} py={2}>
      <Popover
        isOpen={showDesc}
        onClose={() => setShowDesc(false)}
        placement="auto"
        closeOnBlur
      >
        <PopoverTrigger>
          <Tooltip
            variant="dark"
            label={t('reportsDashboard.showStandardDesciption') as string}
            aria-hidden={true}
            isDisabled={showDesc}
          >
            <Box
              onClick={(e) => {
                e.stopPropagation();
                setShowDesc(true);
              }}
              cursor="pointer"
              position="relative"
            >
              <Flex flexDirection="column" alignItems="center" gap={2} py={2}>
                <Text
                  color="primary.800"
                  css={{
                    writingMode: 'vertical-lr',
                  }}
                  transform="rotate(180deg)"
                >
                  {headerData?.header?.id}
                </Text>
              </Flex>
            </Box>
          </Tooltip>
        </PopoverTrigger>
        <PopoverContent bg="white" color="primary.800" padding={6}>
          <PopoverBody p={0}>
            <Flex gap={4} flexDirection="column">
              <Flex justify="space-between" alignItems="center">
                <Text variant="h6" color="primary.800">
                  {headerData?.header?.id}
                </Text>
                <PopoverCloseButton
                  type="button"
                  color="primary.800"
                  position="relative"
                  pb="14px"
                />
              </Flex>
              <Text variant="s2" color="primary.800" whiteSpace="pre-wrap">
                {item.description}
              </Text>
            </Flex>
          </PopoverBody>
        </PopoverContent>
      </Popover>
      <Tooltip label={sortTooltipLabel} variant="dark">
        <Flex>
          <SortingIcon
            column={headerData?.column as any}
            onIconClick={
              isLeaderSuit
                ? headerData?.column.getToggleSortingHandler()
                : undefined
            }
          />
        </Flex>
      </Tooltip>
    </Flex>
  );
}
